/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'interface-question-mark': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g opacity=".7" clip-path="url(#svgicon_interface-question-mark_a)" _fill="#686a7a"><path pid="0" d="M10 18.335c-4.595 0-8.333-3.738-8.333-8.334 0-4.594 3.738-8.333 8.333-8.333 4.595 0 8.333 3.738 8.333 8.333 0 4.596-3.738 8.334-8.333 8.334Zm0-15A6.674 6.674 0 0 0 3.333 10 6.674 6.674 0 0 0 10 16.668a6.675 6.675 0 0 0 6.667-6.667A6.674 6.674 0 0 0 10 3.335Z"/><path pid="1" d="M10.833 12.5H9.167V10H10a1.668 1.668 0 0 0 0-3.333c-.92 0-1.667.746-1.667 1.666H6.667A3.338 3.338 0 0 1 10 5a3.338 3.338 0 0 1 3.333 3.333 3.343 3.343 0 0 1-2.5 3.23v.937ZM10 15.21a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083Z"/></g><defs><clipPath id="svgicon_interface-question-mark_a"><path pid="2" _fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs>'
  }
})
